export default __webpack_public_path__ + "static/media/refer-steps.1d39e17b.png";